require('highcharts/highcharts.src')
require('highcharts/highcharts-more.src')
require('angular')
require('../../../core/translation/translation-module')
require('../number/number-module')
require('../payment/payment-module')

StrokeAnalysisDirective = require('./stroke-analysis/stroke-analysis-directive')
ScoreAnalysisDirective = require('./score-analysis/score-analysis-directive')
StrokeAnalysisService = require('./stroke-analysis/stroke-analysis-service')
BasicAnalysisDirective = require('./basic-analysis/basic-analysis-directive')
BasicAnalysisService = require('./basic-analysis/basic-analysis-service')
TimeSeriesAnalysisDirective = require('./time-series-analysis/time-series-analysis-directive')
TimeSeriesAnalysisService = require('./time-series-analysis/time-series-analysis-service')

modules = [
  'gnp-translation'
  'gnp-number'
  'gnp-payment'
]
angular.module 'gnp-analysis-charts', modules
  .config ['$translateProvider', ($translateProvider) ->
    $translateProvider
      .translations 'en', require('./i18n/en')
      .translations 'ja', require('./i18n/ja')
  ]
  .factory "BasicAnalysisService", BasicAnalysisService
  .directive('gnpStrokeAnalysis', StrokeAnalysisDirective)
  .directive('gnpScoreAnalysis', ScoreAnalysisDirective)
  .directive('gnpBasicAnalysis', BasicAnalysisDirective)
  .factory('StrokeAnalysisService', StrokeAnalysisService)
  .directive('gnpTimeSeriesAnalysis', TimeSeriesAnalysisDirective)
  .factory('TimeSeriesAnalysisService', TimeSeriesAnalysisService)



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/analysis-charts/analysis-charts-module.coffee